import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Feed from "@/pages/Feed";

export const Route = createFileRoute("/_app/feed")({
  component: () => (
    <PageGate pageKey="feed"><Feed /></PageGate>
  ),
});
